import { applySnapshot, getSnapshot, Instance, onSnapshot, types } from 'mobx-state-tree'
import { Agent, agentData } from '../models/Agent'
import { Banks, BanksData } from '../models/Banks'
import { BcAppInfo, BcAppInfoData } from '../models/BcAppInfo'
import { BillPaymentAgentOnboard, BillPaymentAgentOnboardData } from '../models/BillPaymentService/agentOnboard'
import { Consents, ConsentsData } from '../models/Consents'
import { Customer, CustomerData } from '../models/Customer'
import { BeneficiaryDetails, BeneficiaryDetailsData } from '../models/DomesticMoneyTransfer/BeneficiaryDetails'
import { CustomerDetails, CustomerDetailsData } from '../models/DomesticMoneyTransfer/CustomerDetails'
import { DomesticMoneyTransferSession, DomesticMoneyTransferSessionData } from '../models/DomesticMoneyTransfer/Session'
import { TransactionDetails, TransactionDetailsData } from '../models/DomesticMoneyTransfer/TransactionDetails'
import { Message, MessageData } from '../models/Message'
import { RefundCode, RefundCodeData } from '../models/Refund/RefundCode'
import { ReGenerateRefundCode, ReGenerateRefundCodeData } from '../models/Refund/ReGenerateRefundCode'

let initialState = {}
const Root = types
  .model('Root', {
    agent: Agent,
    consents: Consents,
    customer: Customer,
    banks: Banks,
    message: Message,
    bcAppInfo: BcAppInfo,

    //DOMESTIC MONEY TRANSFER SESSION
    moneyTransferSession: DomesticMoneyTransferSession,
    beneficiaryDetails: BeneficiaryDetails,
    customerDetails: CustomerDetails,
    transactionDetails: TransactionDetails,

    //Bill Payment Service 
    BillPaymentAgentOnboard: BillPaymentAgentOnboard,


    //REFUND CODE
    refundCode: RefundCode,
    reGenerateRefundCode: ReGenerateRefundCode,
  })
  .volatile(() => ({}))
  .actions((self) => ({
    init(): void {
      initialState = getSnapshot(self)
    },
    reset(): void {
      try {
        applySnapshot(self, initialState)
      } catch (e) {
        RootStore.message.handleError(e)
      }
    },
  }))
  .views((self) => ({}))

const RootStore: any = Root.create({
  agent: agentData,
  consents: ConsentsData,
  customer: CustomerData,
  banks: BanksData,
  message: MessageData,
  bcAppInfo: BcAppInfoData,

  //DOMESTIC MONEY TRANSFER STORE DATAS
  moneyTransferSession: DomesticMoneyTransferSessionData,
  beneficiaryDetails: BeneficiaryDetailsData,
  customerDetails: CustomerDetailsData,
  transactionDetails: TransactionDetailsData,

  // Bill Payment Store Data
  BillPaymentAgentOnboard: BillPaymentAgentOnboardData,

  //REFUND CODE
  refundCode: RefundCodeData,
  reGenerateRefundCode: ReGenerateRefundCodeData,
})

onSnapshot(RootStore, (snapshot) => {
  console.log('%c%s', 'color: green; background: yellow; font-size: 14px;', 'SnapShot!:', snapshot)
})

export type RootType = Instance<typeof Root>
export { Root, RootStore }
